import { IGridBlock } from './grid.model';

export function computedGridColumnClasses(col: 1 | 2 | 3 | 4 | 5, blok: IGridBlock) {
    return {
        colSpan: blok.colSpan ? blok.colSpan[col - 1] || 12 : 12,
        colSpanTablet: blok.colSpanTablet ? blok.colSpanTablet[col - 1] || 12 : 12,
        colSpanDesktop: blok.colSpanDesktop ? blok.colSpanDesktop[col - 1] || 12 : 12,
    };
}
